import { render } from "./OrderFinalOpinion.vue?vue&type=template&id=7bac55e4&scoped=true"
import script from "./OrderFinalOpinion.vue?vue&type=script&lang=js"
export * from "./OrderFinalOpinion.vue?vue&type=script&lang=js"

import "./OrderFinalOpinion.vue?vue&type=style&index=0&id=7bac55e4&scoped=true&lang=css"

import exportComponent from "/var/www/abg/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bac55e4"]])

export default __exports__